import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../utils/cn';
import type { OmitStylesHTMLAttributes } from '../../types';

export const tagVariants = cva(
    'rocco-tag inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-normal tracking-wide transition-colors focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:outline-hidden',
    {
        variants: {
            variant: {
                default:
                    'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
                /** Muted pill for status labels (e.g. expired) — matches default shape, secondary colours. */
                neutral: 'border-border bg-background text-muted-foreground',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
);

interface TagProps
    extends
        OmitStylesHTMLAttributes<HTMLDivElement>,
        VariantProps<typeof tagVariants> {}

export const Tag = ({ variant, className, ...props }: TagProps) => (
    <div className={cn(tagVariants({ variant }), className)} {...props} />
);
